/**
 * Per-role default landing page.
 *
 * After successful login (or when an authenticated user lands on the bare
 * "/" route) we send them to the page most useful to their role so they
 * don't have to click through the sidebar to get to their daily work.
 *
 * Users can override this by setting `user.default_landing_page` (string
 * path); when present it wins over the role default. Admins always get
 * the full Dashboard so they can override.
 */

const ROLE_LANDING = {
  admin: '/dashboard',
  accounting: '/accounting/insights',
  sales: '/opportunities',
  dispatcher: '/loads',
  office_manager: '/reports',
  carrier_manager: '/carriers',
};

const FALLBACK_LANDING = '/dashboard';

export function getDefaultLandingPage(user) {
  if (!user) return FALLBACK_LANDING;
  const override = (user.default_landing_page || '').trim();
  if (override && override.startsWith('/')) return override;
  return ROLE_LANDING[user.role] || FALLBACK_LANDING;
}

export const LANDING_OPTIONS = [
  { value: '', label: 'Use my role default' },
  { value: '/dashboard', label: 'Dashboard (executive overview)' },
  { value: '/loads', label: 'Loads list' },
  { value: '/opportunities', label: 'Opportunities (CRM)' },
  { value: '/leads', label: 'Leads' },
  { value: '/customers', label: 'Customers' },
  { value: '/carriers', label: 'Carriers' },
  { value: '/accounting', label: 'Accounting' },
  { value: '/accounting/insights', label: 'Insights Hub' },
  { value: '/accounting/kpi-dashboard', label: 'Financial KPI Dashboard' },
  { value: '/accounting/aging', label: 'Aging Dashboard' },
  { value: '/accounting/profit-aggregations', label: 'Margin Aggregations' },
  { value: '/reports', label: 'Reports' },
  { value: '/workflow', label: 'Action Center' },
];
